import { Injectable } from '@angular/core';
import { FieldFormatModalOpenAttributes, FieldFormatModalService } from '@mode/charts/contract';
import { DialogService } from '@mode/shared/ui';
import { first } from 'rxjs';
import { TextFormattingModalComponent } from './text-formatting-modal.component';

@Injectable({
  providedIn: 'root',
})
export class TextFormattingModalService implements FieldFormatModalService {
  constructor(private dialogService: DialogService) {}

  public open(data: FieldFormatModalOpenAttributes): void {
    const dialogRef = this.dialogService.open({
      component: TextFormattingModalComponent,
      matDialogConfig: {
        backdropClass: 'mode-text-formatting-modal-backdrop',
        data,
      },
    });
    dialogRef.afterClosed().pipe(first()).subscribe();
  }
}
